import {DetailTable} from '../../../mapping-classes/detail-table';

export class Requestedmobile implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(requestedMobileCards: any) {
    if (!requestedMobileCards || requestedMobileCards.length === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = requestedMobileCards.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(requestedMobileCards);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen deelnemende rekeningen.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'cardNumber',
      'sequenceNumber',
      'status',
      'creationDate',
      'registrationDataPreparatorDateTime',
      'notificationDataPreparatorDateTime',
      'registrationPassFactoryDateTime',
      'notificationPassFactoryDateTime',
      'replacementCardSequenceNumber',
      'requestReason',
      'secureElementType',
      'secureElementId',
    ];
  }

  setRowData(requestedMobileCards) {
    requestedMobileCards.forEach((requestedMobileCard) => {
      if (this.restrictedData) {
        requestedMobileCard.compensationLimit = this.shieldedText;
        requestedMobileCard.actualBalance = this.shieldedText;
      }
      this.rowData.push(requestedMobileCard);
    });
  }
}
